/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activity_Total_ResponsesInputs */

const en_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Responses`)
};

const de_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt Antworten`)
};

const fr_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des réponses`)
};

const es_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de respuestas`)
};

const it_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale risposte`)
};

const nl_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal reacties`)
};

const pl_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łącznie odpowiedzi`)
};

const fi_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastauksia yhteensä`)
};

const da_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svar i alt`)
};

const sv_analytics_activity_total_responses = /** @type {(inputs: Analytics_Activity_Total_ResponsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt svar`)
};

/**
* | output |
* | --- |
* | "Total Responses" |
*
* @param {Analytics_Activity_Total_ResponsesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_activity_total_responses = /** @type {((inputs?: Analytics_Activity_Total_ResponsesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activity_Total_ResponsesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_activity_total_responses(inputs)
	if (locale === "fr") return fr_analytics_activity_total_responses(inputs)
	if (locale === "es") return es_analytics_activity_total_responses(inputs)
	if (locale === "it") return it_analytics_activity_total_responses(inputs)
	if (locale === "nl") return nl_analytics_activity_total_responses(inputs)
	if (locale === "pl") return pl_analytics_activity_total_responses(inputs)
	if (locale === "fi") return fi_analytics_activity_total_responses(inputs)
	if (locale === "da") return da_analytics_activity_total_responses(inputs)
	if (locale === "sv") return sv_analytics_activity_total_responses(inputs)
	return en_analytics_activity_total_responses(inputs)
});